import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const AssessmentResultApi = createApi({
  reducerPath: "assessmentResultApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAssessmentResultApi: builder.query({
      query: (testId: string) => ({
        url: "/graphql",
        body: gql`
          {
            completedAssessmentAttempts(
              testId: "${testId}"
            ) {
              timestamp
              error
              version
              data {
                attemptDetails {
                  status
                  pdfUrl
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" }
    })
  })
});

export const { useGetAssessmentResultApiQuery } = AssessmentResultApi;
